import Immutable from 'immutable';

import {
	createModuleState,
	createModelForState,
	webapi,
	REPORTED_EXCEPTION,
	DateUtils,
} from 'ps-gui';
import {
	createSearchModel,
	getRawNsndTokenFilterProcessor,
} from '../utils';

const EMPTY_LIST = Immutable.List([]);
const EMPTY_MAP = Immutable.Map({});
const EMPTY_STATE = createModuleState('LabelAdmin');



export default class LabelAdminModel {
	#data;

	constructor(data) {
		this.#data = data || EMPTY_MAP;
	}

	#setProperty(name, value) {
		if (Array.isArray(name)) {
			return new LabelAdminModel(this.#data.setIn(name, value));
		} else {
			return new LabelAdminModel(this.#data.set(name, value));
		}
	}

	#deleteProperty(name) {
		if (Array.isArray(name)) {
			return new LabelAdminModel(this.#data.deleteIn(name));
		} else {
			return new LabelAdminModel(this.#data.delete(name));
		}
	}

	#setInitialized() {
		return new LabelAdminModel(this.#data.set('initialized', true));
	}

	async checkGlobalContextChange(globalContext) {
		if (!globalContext) {
			return this;
		}
		const gcLangId = globalContext.getLanguageId();
		const langId = this.#data.get('langId');
		if (gcLangId === langId) {
			return this;
		}
		let model = this;
		model = await model.initialize(globalContext);
		model = await model.refreshSearch(true);
		return model.#setProperty('languageTimestamp', new Date().getTime());
	}

	getLanguageTimestamp() {
		return this.#data.get('languageTimestamp') || 0;
	}


	async openDetail(producerId, labelId) {
		let res = await webapi.execute('/api/proc/api_labels/getlabel', {
			producerId,
			labelId
		});
		if (res === REPORTED_EXCEPTION) {
			return this;
		}
		return this.#setProperty('detail', Immutable.fromJS(res));
	}

	setDetail(detail) {
		return this.#setProperty('detail', detail);
	}

	hideDetail() {
		return this.#setProperty('detail', null);
	}

	async refreshSearch(dontSavePreference) {
		/*		let fixedFilter = {
			status_group: STATUS_GROUPS.filter(key => statusGroupFilter.get(key))
		};*/

		let srch = this.getSearch(); //.setFixedFilter(fixedFilter);
		if (!srch) {
			return this;
		}
		srch = await srch.search(1);
		return this.setSearch(srch);
	}

	async setPartyId(partyId) {
		let model = this.#setProperty('partyId', partyId);
		let srch = model.getSearch();
		srch = srch.setFixedFilter({
			producer_id: partyId
		});
		model = model.setSearch(srch);
		return model.refreshSearch();
	}

	async initialize() {
		console.log('initialize');

		let pi = await webapi.execute('/api/proc/api_labels/getadmininfo', {});
		if (pi === REPORTED_EXCEPTION) {
			return this;
		}
		const nextYear = (parseInt(pi.config.distributionPeriodId) + 1) + '';
		let model = this.#setProperty('year', pi.config?.distributionPeriodId).#setProperty('isLocked', pi.config?.isLocked !== 'N');
		let startOfYear = DateUtils.parseRawDate(pi.config.distributionPeriodId + '0101'), endOfYear = DateUtils.parseRawDate(pi.config.distributionPeriodId + '1231');
		model = model.#setProperty('startOfYear', startOfYear).#setProperty('endOfYear', endOfYear).#setProperty('startOfYearStr', DateUtils.formatDate(startOfYear)).#setProperty('endOfYearStr', DateUtils.formatDate(endOfYear));
		model = model.#setProperty('nextYear', nextYear);
		let srch = createSearchModel('/api/dq/sv_admin_label').setEntityName('label');
		srch = srch.setProcessFilter(getRawNsndTokenFilterProcessor(['label_name']));
		model = model.setSearch(srch).#setInitialized();
		model = await model.refreshSearch(true);
		return model;
	}

	setSearch(model) {
		return new LabelAdminModel(this.#data.set('search', model.getState()));
	}

	getSearch() {
		return createModelForState(this.#data.get('search'));
	}

	getData() {
		return this.#data;
	}

	getState() {
		return EMPTY_STATE.set('data', this.#data);
	}
}


